// extracted by mini-css-extract-plugin
module.exports = {"root":"TrafficMessageContainer_root_3GU9Z","borderVertical":"TrafficMessageContainer_borderVertical_3lPuD"};